import * as React from "react"

const Input = React.forwardRef(({ className = "", type = "text", ...props }, ref) => {
  return (
    <input
      type={type}
      className={`flex h-10 w-full rounded-md border border-[#2A324B]/20 bg-white px-3 py-2 text-sm text-[#2A324B] placeholder:text-[#2A324B]/40 focus:outline-none focus:ring-2 focus:ring-[#F3D5B5] focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }

